import BaseController from "../../controller/BaseController";
import AdminDataService from "../../util/AdminDataService";
import JSONModel from "sap/ui/model/json/JSONModel";
import { Button$PressEvent } from "sap/m/Button";
import { Dialog$AfterCloseEvent } from "sap/m/Dialog";
import Validator from "../../util/Validator";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class HolidaysController extends BaseController {
    private readonly DIALOG_ID = "DialogCreateUpdateHoliday";

    public async onInit(): Promise<void> {
        AdminDataService.getHolidays();
    }

    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    public async onCreateHoliday(): Promise<void> {
        this.getView().setModel(new JSONModel({
            halfDay: false,
        }), "holiday");
        await this.openDialog(this.DIALOG_ID);
    }

    public async onEdit(oEvent: Button$PressEvent): Promise<void> {
        const selectedContract = oEvent.getSource().getBindingContext("dataModel");
        this.getView().setModel(new JSONModel(selectedContract.getObject()), "holiday");
        await this.openDialog(this.DIALOG_ID);
    }

    public async onSaveDialog(oEvent: Dialog$AfterCloseEvent): Promise<void> {

        const validator = new Validator();
        const valid = validator.validate(oEvent.getSource().getParent());
        if (!valid) return;

        const holidayData = (this.getView().getModel("holiday") as JSONModel).getData();

        if (holidayData.id) {
            AdminDataService.updateHoliday(holidayData);
        } else {
            AdminDataService.createHoliday(holidayData);
        }

        this.destroyDialog(this.DIALOG_ID);
    }
}